import { render, staticRenderFns } from "./Fading.vue?vue&type=template&id=a2caac1e"
import script from "./Fading.vue?vue&type=script&lang=js"
export * from "./Fading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports